import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SvcBtnComponent } from './svc-btn.component';

@NgModule({
  declarations: [
    SvcBtnComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    SvcBtnComponent
  ]
})
export class SvcBtnModule { }
